import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {BulkEditPropertyProps, Option, OptionBulkEditProperty} from './BulkEditDialogProperties'
import Select, {SingleValue} from 'react-select'

interface BulkEditOptionControlProps {
    property: BulkEditPropertyProps
    shouldBlockCancelConfirmCallback: React.Dispatch<React.SetStateAction<boolean>>
    id?: string
}

function _BulkEditOptionControl(props: BulkEditOptionControlProps) {
    const {property, id, shouldBlockCancelConfirmCallback} = props

    const optionProperty = property as OptionBulkEditProperty

    const options = Array.from(optionProperty)
    const selectedOption = options.find(s => s.label === optionProperty.selectedKey)

    const onChange = React.useCallback(
        (newValue: SingleValue<Option>) => {
            if (newValue) {
                optionProperty.selectKey(newValue.label)
            }
        },
        [optionProperty]
    )

    return (
        <Select
            id={id}
            value={selectedOption}
            isClearable={false}
            name={optionProperty.name}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onChange}
            options={options}
            onMenuOpen={() => {
                shouldBlockCancelConfirmCallback(true)
            }}
            onMenuClose={() => {
                shouldBlockCancelConfirmCallback(false)
            }}
        />
    )
}

export const BulkEditOptionControl = observer(_BulkEditOptionControl)
